import { TFunction } from 'i18next';
import { PromotionTemplate } from '@/models/promotion.model';
import { TSelectOptions } from '@/ui';

export const getCouponTemplateOptions = (t: TFunction) =>
  Object.entries(PromotionTemplate).reduce((acc, [key, value]) => {
    if (isNaN(Number(key))) {
      acc.push({
        value: value as number,
        label: t('promotion_template_option', { ns: 'common', context: key }),
      });
    }

    return acc;
  }, [] as TSelectOptions<number>);
